import { api } from '@/api/client';

const VISITOR_KEY = 'sqlmaster.visitor';
const SIGNUP_SOURCE_KEY = 'sqlmaster.signupSource';

export type AnalyticsEventName =
  | 'learn_hub_viewed'
  | 'article_viewed'
  | 'article_query_run'
  | 'article_query_error'
  | 'article_problem_clicked'
  | 'article_course_link_clicked'
  | 'learn_signup_prompt_shown'
  | 'learn_signup_prompt_clicked';

/** Anonim brauzer identifikatori. Xotira yopiq bo'lsa null — hodisa baribir yuboriladi. */
function visitorId(): string | null {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

/** O'z bazamizdagi analitika. Xatosi foydalanuvchiga ta'sir qilmaydi. */
export function trackEvent(name: AnalyticsEventName, props?: Record<string, string>) {
  api.post('/track/event', { name, visitorId: visitorId(), props }).catch(() => undefined);
}

/** Shu sessiyadagi ro'yxatdan o'tish /learn dan boshlandi deb belgilaydi (oxirgi maqola). */
export function rememberLearnSignupSource(articleSlug?: string) {
  try {
    sessionStorage.setItem(SIGNUP_SOURCE_KEY, JSON.stringify({ source: 'learn', articleSlug: articleSlug ?? null }));
  } catch {
    // Xotira yopiq — manbasiz qoladi
  }
}

/** Yangi akkaunt tasdiqlangach chaqiriladi; bir marta yuboriladi. */
export function sendSignupAttribution() {
  try {
    const saved = sessionStorage.getItem(SIGNUP_SOURCE_KEY);
    if (!saved) return;
    sessionStorage.removeItem(SIGNUP_SOURCE_KEY);
    api.post('/track/signup-attribution', JSON.parse(saved)).catch(() => undefined);
  } catch {
    // Atributsiya ro'yxatdan o'tishni to'xtatmasligi kerak
  }
}
